// extracted by mini-css-extract-plugin
export default {"textareaContainer":"WSInputTextarea-module_textareaContainer-v9sUO","textarea":"WSInputTextarea-module_textarea-rkCOy","disabled":"WSInputTextarea-module_disabled-XFrbH"};